var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgSearch = function SvgSvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.245 23.996a.74.74 0 0 1-.53-.22L16.2 17.26a9.8 9.8 0 0 1-2.553 1.579 9.77 9.77 0 0 1-7.51.069 9.74 9.74 0 0 1-5.359-5.262 9.75 9.75 0 0 1-.069-7.51A9.75 9.75 0 0 1 5.97.777a9.74 9.74 0 0 1 7.51-.069 9.74 9.74 0 0 1 5.359 5.262 9.75 9.75 0 0 1 .069 7.51 9.8 9.8 0 0 1-1.649 2.718l6.517 6.518a.75.75 0 0 1-.531 1.28M9.807 1.49a8.3 8.3 0 0 0-3.25.667 8.26 8.26 0 0 0-4.458 4.54 8.26 8.26 0 0 0 .058 6.362 8.26 8.26 0 0 0 4.54 4.458 8.259 8.259 0 0 0 6.362-.059 8.3 8.3 0 0 0 2.594-1.736.365.365 0 0 1 .077-.076 8.2 8.2 0 0 0 1.786-2.728 8.26 8.26 0 0 0-.059-6.362 8.26 8.26 0 0 0-4.54-4.458 8.3 8.3 0 0 0-3.11-.608"
  })));
};
export default SvgSvgSearch;